<template>
	<div>
	  <v-autocomplete v-bind:items="filtered_items" v-model="val" :label="label" :item-text="itemText" :item-value="itemValue" append-outer-icon="add" @click:append-outer="add_to_list" @change="add_to_list">
	  	
	  </v-autocomplete>

	  <span v-for="(val, i) in selected">
 	  	<v-chip close @input="remove_from_list(i)" v-if="can_remove(val)">
	  		{{ get_text(val) }}
		  </v-chip>
		  <v-chip v-if="!can_remove(val)">
		  	{{ get_text(val) }}
		  </v-chip>
		</span>
	</div>
</template>

<script>
import Vue from 'vue'

export default {
  props: {
    'label': String,
    'items': {
      type: Array,
      default () { return [] }
    },
    'item-text': undefined,
    'item-value': undefined,
    'value': {
      type: Array,
      default () { return []; }
    },
    'allow-empty': {
    	type: Boolean,
    	default () { return false; }
    }
  },
  data () {
  	return {
  		val: undefined,
  		selected: []
  	}
  },
  methods: {
  	can_remove(item_id) {
  		var self = this;
  		var a = _.find(this.items, function(item) {
  			return item[self.itemValue] == item_id;
  		});
  		if (this.allowEmpty == false && this.selected.length == 1) return false;
  		if (typeof(a) == "undefined") return false;
  		return true;
  	},
  	get_text (item_id) {
  		var self = this;
  		var a = _.find(this.items, function(item) {
  			return item[self.itemValue] == item_id;
  		});
  		if (typeof(a) == "undefined") return item_id;
			if(typeof(self.itemText) == "function") return self.itemText(a);
  		return a[self.itemText];
  	},
  	add_to_list() {
  		var self = this;
  		if (typeof(this.val) != "undefined" && this.val != null && !this.selected.includes(this.val)) {
	  		this.selected.push(this.val);
  			this.$emit("input", this.selected);
   		}
 			Vue.nextTick(function() {
	  		self.val = undefined;
  		});
  	},
  	remove_from_list(idx) {
  		if (this.allowEmpty == false && this.selected.length == 1) return;
  		this.selected.splice(idx, 1);
  		this.$emit("input", this.selected);
  	}
  },
  computed: {
    filtered_items () {
      var self = this;
      return _.filter(this.items, function(item) {
        return !self.selected.includes(item[self.itemValue]);
      });
    }
  },
  mounted() {
  	this.selected = _.cloneDeep(this.value);
  }
}
</script>
